/* --------------------
 * react-lazy-data module
 * Server context
 * ------------------*/

// Modules
import {createContext} from 'react';

// Exports

export default createContext();
